<template>
  <div>
    <div v-if="showForm">
      <h4 class="text-primary-dark">Notas</h4>
      <form @submit.prevent="saveIncidencia()">
        <div class="form-group mb-1">
          <small>Escriba una nueva nota</small>
          <textarea v-model="texto" class="form-control"></textarea>
        </div>
        <div class="text-right form-group mb-4">
          <input v-if="!sending" type="submit" value="Enviar nota" class="btn btn btn-primary mt-2" :disabled="texto.length < 1"/>
          <button v-else class="btn btn-primary disabled mt-2" disabled>
            <font-awesome-icon icon="spinner" class="fa-spin"/> Enviando
          </button>
        </div>
      </form>
    </div>

    <loading v-if="loading"/>
    <div v-else>
        <div v-if="!loading && incidenciasCliente.length == 0" class="text-center">Todavía no hay notas</div>
        <div v-for="incidencia in incidenciasCliente" :key="incidencia.id" class="d-flex flex-row mb-4">
        <div style="width: 75px;">
          <img :src="getAvatar(incidencia)" class="avatar border border-secondary">
        </div>
        <div class="w-100 position-relative">
          <img src="/clientes/flecha-globo-texto.png" class="flecha-globo-texto"/>
          <div v-html="incidencia.descripcion" class="border rounded py-1 px-2 texto-incidencia bg-light"></div>
          <span class="text-primary-dark small d-flex">
            <span><font-awesome-icon icon="clock"/> {{incidencia.fechaCreacion|fechaHora}}</span>
            <span class="ml-auto">{{ getUsuario(incidencia) }} <font-awesome-icon icon="user" class="ml-1"/></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
export default {
  data() { 
    return {
      loading: true,
      sending: false,
      texto: '',
      incidenciasCliente: []
    }
  },
  props: {
    tipoObjeto: {
      default: null
    },
    idObjeto: {
      default: null
    },
    showForm: {
      default: true
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      //incidenciasCliente: 'incidenciasCliente',
      credentials: 'credentials'
    })
  },
  mounted() {
    //this.$store.dispatch("clearIncidenciasCliente");
    this.getIncidenciasCliente();
  },
  methods: {
    saveIncidencia() {
      this.sending = true;
      let url = this.urlBase + 'incidenciasClientes';
      let options = {
      };
      let data = {
        objeto: this.idObjeto,
        descripcion: this.texto,
        tipoObjeto: parseInt(this.tipoObjeto)
      };

      this.$http.post(url, data, options).then(
        response => {
          this.texto = "";
          this.getIncidenciasCliente();
        },
        error => {
          this.sending = false;
          if (error.body.error.message && error.body.error.message != '') {
            alert(error.body.error.message);
          } else {
            alert("Ha ocurrido un error desconocido");
          }
        }
      );
    },
    getIncidenciasCliente() {
      this.incidencias = [];

      let grupos = [
        'incidenciaCliente.usuarioCreacion',
        'incidenciaCliente.usuarioModificacion'
      ]
      let params = {
        'tipoObjeto': this.tipoObjeto,
        'idObjeto': this.idObjeto,
        'grupos': grupos.join(','),
        'page': 1
      }

      let url = this.urlBase + 'incidenciasClientes?' + util.objToQuery(params);
      this.$http.get(url).then( 
        (response) => {
          this.loading = false;
          this.sending = false;
          this.incidenciasCliente = response.body.items;
          for (let i = 2; i <= response.body.totalPages; i++){
            params.page = i;
            url = this.urlBase + 'incidenciasClientes?' + util.objToQuery(params);
              
            this.$http.get(url).then( 
              (response) => {
                response.body.items.forEach(function(incidenciaCliente){
                  this.incidenciasCliente.push(incidenciaCliente);
                }, this);
              },
              (error) => {
              }
            , this);
            }
        },
        (error) => {
          this.loading = false;
          this.sending = false;
        }
      , this);
    },

    getAvatar(incidencia) {
      if (incidencia.perfilCreador == 1 && incidencia.idCreador) {
        return this.urlBase + 'avatares/' + incidencia.idCreador + '?token=' + this.credentials.token;
      }
      if (incidencia.perfilCreador == 2 && incidencia.idCreador) {
        return this.urlBase + 'avatares_usuarios_colaboradores/' + incidencia.idCreador + '?token=' + this.credentials.token;
      }
      return this.urlBase + 'avatares/' + incidencia.usuarioCreacion.id + '?a=1&token=' + this.credentials.token;
    },

    avatar: function(id){
      console.log("avatar: " + id);
      let url = this.urlBase + 'avatares/' + id;

      this.$http.get(url).then(
        response => {
            return response;
        },
        error => {
        }
      );
    },

    getUsuario: function(incidencia){
      console.log(incidencia);
      if (incidencia.nombreCreador) {
        return incidencia.nombreCreador.toUpperCase();
      }

      if (incidencia.usuarioCreacion.login == 'WEB' && incidencia.perfilCreador && incidencia.perfilCreador == 2) {
        return 'COLABORADOR'
      } else if (incidencia.usuarioCreacion.login == 'WEB') {
        return 'YO';
      } else {
        return incidencia.usuarioCreacion.login;
      }
    }
  },
  components: {
    Loading
  }
}
</script>

<style scoped>
.texto-incidencia {
  min-height: 50px;
}
.flecha-globo-texto {
  position: absolute;
  margin-left: -7px;
  margin-top: 17px;
  z-index: 2000;
}
</style>
